import { render, staticRenderFns } from "./DoKoCreateDesk.vue?vue&type=template&id=b8f03b04&scoped=true&"
import script from "./DoKoCreateDesk.vue?vue&type=script&lang=ts&"
export * from "./DoKoCreateDesk.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoCreateDesk.vue?vue&type=style&index=0&id=b8f03b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f03b04",
  null
  
)

export default component.exports